exports = module.exports = require("../../../../common/temp/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body{margin:0;background-color:#2e2837;scroll-behavior:smooth}", ""]);

